module.exports = __webpack_public_path__ + "static/media/photo-video.c310d75d.svg";